// settings.api.ts
import api from "./axios";

export interface Setting {
  id: number;
  key: string;
  value: string;
  type: "integer" | "boolean" | "text";
  module: string;
  description?: string;
}

export interface DevCleanupOptions {
  documents?: boolean;
  partiesAndAccounts?: boolean;
  commissions?: boolean;
  stock?: boolean;
  notifications?: boolean;
  audit?: boolean;
  resetCounters?: boolean;
}

export interface DevCleanupResult {
  deleted: Record<string, number>;
  updated: Record<string, number>;
  reset: Record<string, number>;
}

export const settingsApi = {
  list: () => api.get<Setting[]>("/settings"),
  update: (key: string, value: string) => api.patch(`/settings/${key}`, { value }),
  // Manager+ readable (unlike list/getByKey above, admin+ only) — powers the
  // "Réattribuer" visibility check everywhere, same pattern as maintenance-mode's own /status.
  attributionReassignmentStatus: () =>
    api.get<{ enabled: boolean }>("/settings/attribution-reassignment/status"),
  devCleanup: (payload: { options: DevCleanupOptions; confirmation: string }) =>
    api.post<DevCleanupResult>("/settings/dev-cleanup", payload),
};
